
import Index from 'components/ckan/training/Index.jsx'
import clientPromise from "lib/mddb.mjs";
import computeFields from "lib/computeFields";
import fs from "fs"

export default function CKANTrainingPage({casestudies}){
  return(
    <Index casestudies={casestudies} />
  )
}

export async function getStaticProps() {
  const mddb = await clientPromise;
  const caseStudiesFiles = await mddb.getFiles({ folder: "showcase/case-studies" });
  const caseStudiesMetadataPromises = caseStudiesFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const caseStudiesList = await Promise.all(caseStudiesMetadataPromises);

  return {
    props: {
      meta: {
        title: "CKAN Training",
        showSidebar: false,
        showToc: false,
        showComments: false,
        showEditLink: false,
        urlPath: "",
        description: "Engage properly in every CKAN step with the tutoring of Datopian professionals."
      },
      casestudies: caseStudiesList,
    },
  };
};